<template>
  <div class="layout">
      <p class="layout_left">
        <span class="layout_left_l">{{message.title}}</span>
        <span class="layout_left_r">/&nbsp;{{message.en}}</span>
      </p>
      <p class="layout_right" v-if="show" @click="$emit('click')">
        <span>更多</span>
        <img src="../assets/images/new_image/more.png" alt="">
      </p>
  </div>
</template>

<script>
export default {
  props:{
    message:{
      type:Object,
      default:{}
    },
    show:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
.layout{
  border-bottom: 1px solid #EDEDED;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 21px;
  position: relative;

  &_left{
    &_l{
      color: #333;
      font-size: 24px;
    }

    &_l::before{
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 42px;
      height: 4px;
      background: #2F89EB;
    }

    &_r{
      color: #999;
      font-size: 18px;
    }
  }

  &_right{
    color: #666;
    font-size: 18px;
    cursor: pointer;
    padding-top: 7px;
    display: flex;
    align-items: center;

    img{
      margin-left: 8px;
      width: 17px;
      height: 17px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/moduleTitle.vue